import styled from 'styled-components'

export const ModalShell = styled.div`
    display: grid;
    grid-template-columns: 1fr 320px;
    gap: 20px;
    align-items: start;

    @media (max-width: 900px) {
        grid-template-columns: 1fr;
    }
`

export const ModalContentWrap = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`

export const ModalTopBar = styled.div`
    display: flex;
    justify-content: flex-end;
    width: 100%;
`

export const FormCard = styled.div`
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    overflow: hidden;
    background: #fff;
`

export const FormCardHead = styled.div`
    padding: 12px 18px;
    background: linear-gradient(135deg, #3730a3 0%, #4f46e5 100%);
    color: #fff;
    font-weight: 600;
    font-size: 14px;
`

export const FormCardBody = styled.div`
    padding: 18px 20px;
`

export const FieldRow = styled.div`
    margin-bottom: 16px;

    label {
        display: block;
        font-weight: 600;
        font-size: 12.5px;
        margin-bottom: 6px;
        color: #0f172a;
    }

    .hint {
        display: block;
        font-size: 11.5px;
        color: #64748b;
        margin-top: 4px;
    }

    .req {
        color: #dc2626;
    }
`

export const AutoEmailToggle = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 14px;
    padding: 12px 14px;
    background: ${({ $off }) => ($off ? '#f8fafc' : '#eef2ff')};
    border: 1px solid ${({ $off }) => ($off ? '#cbd5e1' : '#c7d2fe')};
    border-radius: 8px;
    cursor: pointer;

    .toggle-label {
        font-weight: 600;
        font-size: 13px;
        color: #0f172a;
    }

    .toggle-desc {
        font-size: 11.5px;
        color: #334155;
        margin-top: 2px;
    }
`

export const CompactToggleCard = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    background: ${({ $off }) => ($off ? '#f8fafc' : '#eef2ff')};
    border: 1px solid ${({ $off }) => ($off ? '#cbd5e1' : '#c7d2fe')};
    border-radius: 8px;

    .toggle-copy {
        display: flex;
        flex-direction: column;
        gap: 2px;
    }

    .toggle-label {
        font-weight: 600;
        font-size: 12.5px;
        color: #0f172a;
        line-height: 1.2;
    }

    .toggle-desc {
        font-size: 11px;
        color: #475569;
        line-height: 1.3;
    }
`

export const PreviewCard = styled.div`
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    overflow: hidden;
    background: #fff;
    position: sticky;
    top: 0;
`

export const PreviewHead = styled.div`
    padding: 11px 16px;
    background: #0f172a;
    color: #fff;
    font-weight: 600;
    font-size: 13px;
`

export const PreviewBody = styled.div`
    padding: 16px 18px;
    max-height: 60vh;
    overflow-y: auto;
`

export const PreviewSection = styled.div`
    margin-bottom: 16px;

    h4 {
        margin: 0 0 8px;
        font-size: 11px;
        text-transform: uppercase;
        letter-spacing: 0.6px;
        color: #64748b;
        font-weight: 600;
    }
`

export const RecipientRow = styled.div`
    display: flex;
    align-items: center;
    gap: 9px;
    padding: 6px 0;
    border-bottom: 1px dashed #e2e8f0;
    font-size: 12.5px;

    &:last-child {
        border-bottom: none;
    }

    .avatar {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background: #eef2ff;
        color: #3730a3;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 10px;
        font-weight: 700;
        flex-shrink: 0;
    }

    .who {
        flex: 1;
        min-width: 0;
    }

    .name {
        font-weight: 600;
        word-break: break-word;
    }

    .mail {
        font-size: 11px;
        color: #64748b;
        word-break: break-all;
    }

    .badge {
        font-size: 10px;
        padding: 1px 7px;
        border-radius: 999px;
        font-weight: 600;
        flex-shrink: 0;
        background: ${({ $variant }) => {
            if ($variant === 'external') return '#fef3c7'
            if ($variant === 'customer') return '#ecfeff'
            return '#ecfdf5'
        }};
        color: ${({ $variant }) => {
            if ($variant === 'external') return '#92400e'
            if ($variant === 'customer') return '#155e75'
            return '#065f46'
        }};
    }
`

export const PreviewSummary = styled.div`
    background: #ecfdf5;
    color: #065f46;
    padding: 10px 12px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
`

export const AutoEmailBadge = styled.span`
    display: inline-block;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
    background: ${({ $on }) => ($on ? '#ecfdf5' : '#f1f5f9')};
    color: ${({ $on }) => ($on ? '#065f46' : '#64748b')};
`

export const GroupCardMetaRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 6px;
    font-size: 13px;

    .label {
        font-weight: 600;
        color: #334155;
        min-width: 96px;
        flex-shrink: 0;
    }

    .value {
        color: #0f172a;
        font-weight: 500;
    }
`
